// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"modal_modalFooter__JitSd"};